import React, { useEffect, useState } from 'react'
import tokenService from '../../../../Services/tokenService'
import { HorizontalLoader } from 'Components'
import { CurrencyFormatter } from 'Helpers'

interface TokenPoolData {
  totalTokens: number
  availableTokens: number
  soldTokens: number
  tokenValueNairaMajor: number
}

const TokenPool = () => {
  const [tokenPool, setTokenPool] = useState<TokenPoolData | null>(null)
  const [loading, setLoading] = useState(false)

  const getTokenPool = async () => {
    setLoading(true)
    try {
      const response = await tokenService.getTokenPool()
      setTokenPool(response.data.data)
    } catch (error) {
      console.error('Error fetching token pool:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getTokenPool()
  }, [])

  return (
    <div className='mt-4'>
      <div className='row'>
        <div className='col-md-5'>
          <div className='card border-0'>
            <div className='card-body'>
              {loading ? (
                <p>
                  <HorizontalLoader></HorizontalLoader>
                </p>
              ) : tokenPool ? (
                <ul className='list-group border-0'>
                  <li className='list-group-item d-flex justify-content-between align-items-center border-0'>
                    <span className='fw-medium'>Total Tokens:</span>
                    <span>{tokenPool.totalTokens}</span>
                  </li>
                  <li className='list-group-item d-flex justify-content-between align-items-center border-0'>
                    <span className='fw-medium'>Available Tokens:</span>
                    <span>{tokenPool.availableTokens}</span>
                  </li>
                  <li className='list-group-item d-flex justify-content-between align-items-center border-0'>
                    <span className='fw-medium'>Sold Tokens:</span>
                    <span>{tokenPool.soldTokens}</span>
                  </li>
                  <li className='list-group-item d-flex justify-content-between align-items-center border-0'>
                    <span className='fw-medium'>Token Value:</span>
                    <span>{CurrencyFormatter(tokenPool.tokenValueNairaMajor)}</span>
                  </li>
                </ul>
              ) : (
                <p>No token pool data available.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TokenPool
